// extracted by mini-css-extract-plugin
module.exports = {"catchImagesGrid":"HeaderSection_catchImagesGrid__v4Joi","catchImageWrapper":"HeaderSection_catchImageWrapper__1jgP5","catchImageOverlay":"HeaderSection_catchImageOverlay__ehVet"};